import SegmentedControlMini from '../../../common/segmented-control-mini';
import { ProfileEvent, useProfileInfo } from './profile-context';

export enum DetailType {
    Self = 'Self',
    Others = 'Others',
}

const SEGMENTS = [DetailType.Self, DetailType.Others];

export const SelfOthers = () => {
    const { state: profileState, dispatch: profileDispatch } = useProfileInfo();
    return (
        <SegmentedControlMini
            additionalClasses="portfolio-details-tabs portfolio-demat-tabs"
            segments={['', '']}
            segmentsSpan={SEGMENTS}
            onSegmentChanged={(selectedSegmentIndex: number) => {
                profileDispatch({
                    action: ProfileEvent.setInvestType,
                    payload: SEGMENTS[selectedSegmentIndex]
                })

            }}
            selectedSegmentIndex={SEGMENTS.findIndex((str: string) => str === profileState.investType)}
            key={profileState.investType}
        />
    );
};
